<template>
    <btn
        gray
        @click="startBuilding"
    >
        {{ $t('AI_BUILD') }}
    </btn>
</template>

<script>
    import Btn from '../ui/Btn.vue';

    export default {
        components: {
            Btn,
        },

        computed: {
            packType() {
                return this.$store.state.packType;
            },
        },

        methods: {
            startBuilding() {
                this.closeModal();

                this.$store.state.customizer.mainController.trackAction({
                    action: 'ai-selfie-build',
                });

                // Just close the modal since we are already in the loaded state.

                // // Show main loading spinner
                // this.$store.dispatch('showAiSpinner', true);

                // // Begin customization.
                // this.$store.dispatch('log', {
                //     level: 'info',
                //     message: 'Start customization from splash page',
                // });

                // this.$store.dispatch('startCustomization', {
                //     mode: this.packType,
                // });
            },

            closeModal() {
                this.$store.dispatch('showAiModal', false);
            },
        },
    };
</script>
